export interface Company {
    first_name?: string;
    last_name?: string;
    company_name?: string | null;
    by?: string;
}

// to single object maping
export const mapCompany = (data:any): Company => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: Company ={
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        by: data.by,
        
    }
    return res;
}

// maping list objects
export const mapCompanys = (data:any[]): Company[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapCompany);
}



export interface CoverPage {
    title?: string;
    text?: string;
    comapny?: Company | null;
}
export const mapCoverPage = (data: any): CoverPage => {
    if (!data) throw new Error('Invalid Data');
    return {
        title: data.title,
        text: data.text,
        comapny: data.comapny ? mapCompany(data.comapny) : null,
    };
};


export interface ArchitectData {
    id?: number;
    for?: string;
    percentage?: number | null;
    value?: number | null;
    note?: string | null;
    before_percentage?: number | null;
    before_value?: number | null;
}

export const mapArchitectData = (data: any): ArchitectData => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        for: data.for,
        percentage: data.percentage,
        value: data.value,
        note: data.note,
        before_percentage: data.before_percentage,
        before_value: data.before_value,
    };
};





export interface BuilderData {
    id?: number;
    for?: string;
    percentage?: number | null;
    value?: number | null;
    note?: string | null;
    before_percentage?: number | null;
    before_value?: number | null;
}

export const mapBuilderData = (data: any): BuilderData => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        for: data.for,
        percentage: data.percentage,
        value: data.value,
        note: data.note,
        before_percentage: data.before_percentage,
        before_value: data.before_value,
    };
};


export interface SubSectionItem {
    item_id?: number;
    sub_section_id?: number;
    item_name?: string;
    item_no?: string;
    after_item_no?: number;
    item_amount_total?: number;
    architect_data?: ArchitectData | null;
    builder_data?: BuilderData | null;
    client_note?: string | null;
}

export const mapSubSectionItem = (data: any): SubSectionItem => {
    if (!data) throw new Error('Invalid Data');
    return {
        item_id: data.item_id,
        sub_section_id: data.sub_section_id,
        item_name: data.item_name,
        item_no: data.item_no,
        after_item_no: data.after_item_no,
        item_amount_total: data.item_amount_total,
        architect_data: data.architect_data ? mapArchitectData(data.architect_data) : null,
        builder_data: data.builder_data ? mapBuilderData(data.builder_data) : null,
        client_note: data.client_note,
    };
};

export const mapSubSectionItems = (data: any[]): SubSectionItem[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapSubSectionItem);
};


export interface SubSection {
    sub_section_id?: number;
    section_id?: number;
    sub_section_name?: string;
    sub_section_no?: string;
    after_sub_section_no?: number;
    sub_section_amount?: number;
    sub_section_item_data?: SubSectionItem[];
}

export const mapSubSection = (data: any): SubSection => {
    if (!data) throw new Error('Invalid Data');
    return {
        sub_section_id: data.sub_section_id,
        section_id: data.section_id,
        sub_section_name: data.sub_section_name,
        sub_section_no: data.sub_section_no,
        after_sub_section_no: data.after_sub_section_no,
        sub_section_amount: data.sub_section_amount,
        sub_section_item_data: data.sub_section_item_data ? mapSubSectionItems(data.sub_section_item_data) : [],
    };
};

export const mapSubSections = (data: any[]): SubSection[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapSubSection);
};


export interface SectionItem {
    item_id?: number;
    section_id?: number;
    item_name?: string;
    item_no?: string;
    after_item_no?: number;
    item_amount_total?: number;
    architect_data?: ArchitectData | null;
    builder_data?: BuilderData | null;
    client_note?: string | null;
}
export const mapSectionItem = (data: any): SectionItem => {
    if (!data) throw new Error('Invalid Data');
    return {
        item_id: data.item_id,
        section_id: data.section_id,
        item_name: data.item_name,
        item_no: data.item_no,
        after_item_no: data.after_item_no,
        item_amount_total: data.item_amount_total,
        architect_data: data.architect_data ? mapArchitectData(data.architect_data) : null,
        builder_data: data.builder_data ? mapBuilderData(data.builder_data) : null,
        client_note: data.client_note,
    };
};

export const mapSectionItems = (data: any[]): SectionItem[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapSectionItem);
};


export interface Section {
    section_id?: number;
    project_tender_part_id?: number;
    section_name?: string;
    section_no?: string;
    after_section_no?: number;
    section_amount?: number;
    sub_section_data?: SubSection[];
    section_item_data?: SectionItem[];
}
export const mapSection = (data: any): Section => {
    if (!data) throw new Error('Invalid Data');
    return {
        section_id: data.section_id,
        project_tender_part_id: data.project_tender_part_id,
        section_name: data.section_name,
        section_no: data.section_no,
        after_section_no: data.after_section_no,
        section_amount: data.section_amount,
        sub_section_data: data.sub_section_data ? mapSubSections(data.sub_section_data) : [],
        section_item_data: data.section_item_data ? mapSectionItems(data.section_item_data) : [],
    };
};

export const mapSections = (data: any[]): Section[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapSection);
};


export interface Preliminary {
    priliminiery_id?: number;
    project_tender_part_id?: number;
    ref_number?: string;
    item_name?: string;
    after_ref_number?: number;
    priliminiery_amount_total?: number;
    architect_data?: ArchitectData | null;
    builder_data?: BuilderData | null;
    client_note?: string | null;
}
export const mapPreliminary = (data: any): Preliminary => {
    if (!data) throw new Error('Invalid Data');
    return {
        priliminiery_id: data.priliminiery_id,
        project_tender_part_id: data.project_tender_part_id,
        ref_number: data.ref_number,
        item_name: data.item_name,
        after_ref_number: data.after_ref_number,
        priliminiery_amount_total: data.priliminiery_amount_total,
        architect_data: data.architect_data ? mapArchitectData(data.architect_data) : null,
        builder_data: data.builder_data ? mapBuilderData(data.builder_data) : null,
        client_note: data.client_note,
    };
};

export const mapPreliminaries = (data: any[]): Preliminary[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapPreliminary);
};


export interface DataForVariation {
    id?: number;
    valuation_edit_count_id?: number;
    variation_no?: string;
    amount?: number;
    item_name?: string;
    path?: string | null;
    file_upload_date?: string | null;
}
export const mapDataForVariation = (data: any): DataForVariation => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        valuation_edit_count_id: data.valuation_edit_count_id,
        variation_no: data.variation_no,
        amount: data.amount,
        item_name: data.item_name,
        path: data.path,
        file_upload_date: data.file_upload_date,
    };
};

export const mapDataForVariations = (data: any[]): DataForVariation[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapDataForVariation);
};


export interface DataForContingency {
    id?: number;
    valuation_edit_count_id?: number;
    item_name?: string;
    amount?: number;
}
export const mapDataForContingency = (data: any): DataForContingency => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        valuation_edit_count_id: data.valuation_edit_count_id,
        item_name: data.item_name,
        amount: data.amount,
    };
};

export const mapDataForContingencies = (data: any[]): DataForContingency[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapDataForContingency);
};


export interface Variation {
    variation_total?: number | null;
    data?: DataForVariation[];
}
export const mapVariation = (data: any): Variation => {
    if (!data) throw new Error('Invalid Data');
    return {
        variation_total: data.variation_total,
        data: data.data ? mapDataForVariations(data.data) : [],
    };
};


export interface Contingency {
    contingency_total?: number;
    variation_total?: number;
    data?: DataForContingency[];
}
export const mapContingency = (datax: any): Contingency => {
    if (!datax) throw new Error('Invalid Data');
    return {
        contingency_total: datax.contingency_total,
        variation_total: datax.variation_total,
        data: datax.data ? mapDataForContingencies(datax.data) : [],
    };
};


export interface SectionSummary {
    section_id?: number;
    section_name?: string;
    section_amount?: number;
}
export const mapSectionSummary = (data: any): SectionSummary => {
    if (!data) throw new Error('Invalid Data');
    return {
        section_id: data.section_id,
        section_name: data.section_name,
        section_amount: data.section_amount,
    };
};

export const mapSectionSummaries = (data: any[]): SectionSummary[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapSectionSummary);
};


export interface Summary {
    section_data?: SectionSummary[];
    section_sub_total?: number;
    gross_total?: number;
    client_discretion_draw?: number;
    sub_total?: number;
    less_retention_percentage?: number;
    less_retention?: number;
    net_total?: number;
    before_valuation_edit_count?: number | null;
    less_previous_payment?: number;
    final_total?: number;
    valuation_edit_no?: number;
    valuation_edit_created?: string;
}

export const mapSummary = (data: any): Summary => {
    if (!data) throw new Error('Invalid Data');
    return {
        section_data: data.section_data ? mapSectionSummaries(data.section_data) : [],
        section_sub_total: data.section_sub_total,
        gross_total: data.gross_total,
        client_discretion_draw: data.client_discretion_draw,
        sub_total: data.sub_total,
        less_retention_percentage: data.less_retention_percentage,
        less_retention: data.less_retention,
        net_total: data.net_total,
        before_valuation_edit_count: data.before_valuation_edit_count,
        less_previous_payment: data.less_previous_payment,
        final_total: data.final_total,
        valuation_edit_no: data.valuation_edit_no,
        valuation_edit_created: data.valuation_edit_created,
    };
};



export interface DataForValuationEdit {
    cover_page?: CoverPage | null;
    section_data?: Section[];
    priliminiery_data?: Preliminary[];
    variation_data?: Variation | null;
    contingency_data?: Contingency | null;
    summary_data?: Summary | null;
}
export const mapDataForValuationEdit = (data: any): DataForValuationEdit => {
    if (!data) throw new Error('Invalid Data');
    return {
        cover_page: data.cover_page ? mapCoverPage(data.cover_page) : null,
        section_data: data.section_data ? mapSections(data.section_data) : [],
        priliminiery_data: data.priliminiery_data ? mapPreliminaries(data.priliminiery_data) : [],
        variation_data: data.variation_data ? mapVariation(data.variation_data) : null,
        contingency_data: data.contingency_data ? mapContingency(data.contingency_data) : null,
        summary_data: data.summary_data ? mapSummary(data.summary_data) : null,
    };
};


export interface ValuationEditDetails {
    id?: number;
    valuation_edit_id?: number;
    valuation_edit_no?: number;
    valuation_edit_created?: string | null;
    is_fixed?: 1 | 0;
    data?: DataForValuationEdit;
}
export const mapValuationEditDetails = (data: any): ValuationEditDetails => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        valuation_edit_id: data.valuation_edit_id,
        valuation_edit_no: data.valuation_edit_no,
        valuation_edit_created: data.valuation_edit_created,
        is_fixed: data.is_fixed,
        data: data.data ? mapDataForValuationEdit(data.data) : undefined,
    };
};

export const mapValuationEditDetailsList = (data: any[]): ValuationEditDetails[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapValuationEditDetails);
};


export interface ValuationData {
    id?: number;
    folder_id?: number;
    valuation_edit_data?: ValuationEditDetails[];
  
}
export const mapValuationData = (data: any): ValuationData => {
    if (!data) throw new Error('Invalid Data');
    return {
        id: data.id,
        folder_id: data.folder_id,
        valuation_edit_data:mapValuationEditDetailsList(data.valuation_edit_data) ,
      
    };
};

export const mapValuationDataList = (data: any[]): ValuationData[] => {
    if (!Array.isArray(data)) throw new Error('Invalid Data');
    return data.map(mapValuationData);
};


